import api from "core/services/api";

import { default as useSWR, SWRConfig, useSWRConfig } from "swr";
import { useCommonState } from "core/context/useContext";
import { useEffect } from "react";
import { useSelector } from "react-redux";

/**
 * SWR 설정
 * @param {object} children - 자식 컴포넌트
 * @returns {object} SWRConfig - SWR 설정
 */
export const SWR = ({ children }) => {
  const info = useSelector((s) => s.User?.id) || null;

  const fetcher = async (url) => {
    try {
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      throw error;
    } 
  }

  const { data, error, mutate } = useSWR(info ? '/user/session' : null, fetcher, {
    revalidateOnFocus: true,              // 포커스 시 재검증 활성화
    revalidateIfStale: true,              // 오래된 데이터 재검증
    focusThrottleInterval: 5000,          // 포커스 재검증 5초 제한
  });

  // if (data) console.log(data.content.message);
  if (error) console.log(error.response.data.errors);

  /**
   * visibilitychange 이벤트를 감지하여 세션 재검증
   * iframe으로 포커스가 이동하는 경우에도 화면으로 복귀 시 세션 체크
   */
  useEffect(() => {
    if (!info) return;

    const handleVisibilityChange = () => {
      // 페이지가 다시 visible 상태가 되었을 때 세션 체크
      if (document.visibilityState === 'visible') {
        mutate();
      }
    };

    // visibilitychange 이벤트 리스너 등록
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      // 컴포넌트 언마운트 시 이벤트 리스너 제거
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [info, mutate]);

  return (
    <SWRConfig value={{
      fetcher,
      shouldRetryOnError: false,            // 에러 발생시 재시도 여부
      revalidateOnFocus: true,              // 포커스 시 재검증 활성화
      revalidateIfStale: true,              // 오래된 데이터 재검증
      focusThrottleInterval: 5000,          // 포커스 재검증 5초 제한
    }}>
      {data || !info ? children : null}
    </SWRConfig>
  )
}
